import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <div className="footer">
      <p>&copy; 2024 All rights reserved Domtom Pvt. Ltd.</p>
    </div>
  );
};

export default Footer; 